import { render, staticRenderFns } from "./ProfessionListItem.vue?vue&type=template&id=7d9ed044&"
import script from "./ProfessionListItem.vue?vue&type=script&lang=js&"
export * from "./ProfessionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports